module.exports = __webpack_public_path__ + "static/media/360.e602c746.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/360.svg
// module id = 262
// module chunks = 0